import { FiAlertTriangle } from "react-icons/fi";
import { Button } from "../../pages/helpCenter";


export const ConfirmDialog = ({ open, title, message, confirmLabel = "Delete", onConfirm, onCancel }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/40 backdrop-blur-[2px] p-4">
      <div className="w-full max-w-sm rounded-2xl bg-white shadow-xl ring-1 ring-black/5">
        <div className="flex items-start gap-3 px-6 pt-6 pb-2">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rose-50 text-rose-600">
            <FiAlertTriangle size={18} />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
            <p className="mt-1 text-sm text-slate-500">{message}</p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 px-6 py-4">
          <Button variant="secondary" size="sm" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="danger" size="sm" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}